import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bfed261"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "modalHeader" }
const _hoisted_3 = { class: "closer" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "modalBody" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "d-flex justify-content-around" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("i", {
          class: "fa fa-times",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Gestisci richiesta di pagamento",
          text: "Gestisci richiesta di pagamento"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Utente:",
          text: "Utente:"
        }),
        _hoisted_6,
        _createElementVNode("b", null, _toDisplayString(_ctx.richiesta.user.name), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Importo:",
          text: "Importo:"
        }),
        _hoisted_7,
        _createElementVNode("b", null, _toDisplayString(_ctx.vm.importo), 1)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Data ricevuta:",
          text: "Data ricevuta:"
        }),
        _hoisted_8,
        _createElementVNode("b", null, _toDisplayString(_ctx.$filters.date(_ctx.vm.data)), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Numero ricevuta",
            text: "Numero ricevuta"
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.numeroRicevuta) = $event))
        }, null, 512), [
          [_vModelText, _ctx.vm.numeroRicevuta]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("label", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Note",
            text: "Note"
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vm.note) = $event))
        }, null, 512), [
          [_vModelText, _ctx.vm.note]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Approva richiesta e crea ricevuta",
            text: "Approva richiesta e crea ricevuta"
          })
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Elimina richiesta",
            text: "Elimina richiesta"
          })
        ])
      ])
    ])
  ]))
}